import * as React from 'react';
import { EstimationDealTypeBanner } from '../../components/EstimationDealTypeBanner';

import { useDealTypeText } from './utils';

export const EstimationDealTypeBannerContainer: React.FC = () => {
  const dealTypeText = useDealTypeText();

  if (!dealTypeText) {
    return null;
  }

  return <EstimationDealTypeBanner dealTypeText={dealTypeText} />;
};

EstimationDealTypeBannerContainer.displayName = 'EstimationDealTypeBannerContainer';
